

import { Typography } from '@mui/material';
import React,{useEffect,useState} from 'react';
import ProjectDisplay from './ProjectDisplay';
import ProjectGallery from './ProjectGallery'
function About() {


  

   

  return (
    <div className="App" >
    <ProjectDisplay/>
    <ProjectGallery/>
    </div>
  );
}

export default About;
